<div class="main-ho-executive-summary">
  <div>
      <p class="title-section">Resumen Ejecutivo</p>
  </div>
  <div class="loading-shade" *ngIf="isLoading">
      <mat-spinner *ngIf="isLoading"></mat-spinner>
  </div>
  <div class="handover-files">
    <div class="top">
        <h2>Adjunto del Resumen Ejecutivo</h2>
        <div>
            <div *ngIf="executiveSummaryAttachment == null">
                0{{ "/" + fileLimit + " Archivos" }}
              </div>
              <div *ngIf="executiveSummaryAttachment != null">
                {{ executiveSummaryAttachment?.length + "/" + fileLimit + " Archivos" }}
              </div>
        </div>
        <ng-container *ngIf="executiveSummaryAttachment?.length < fileLimit">
            <input
              type="file"
              class="file-input"
              accept=".xls, .xlsx, .pdf"
              (change)="onFileSelected($event)"
              #fileUpload
              style="display: none"
            />
            <div class="attach" title="Documento">
              <button
                mat-button
                class = "upload-button"
                (click)="fileUpload.click()"
                [disabled]="readOnlyContent">
                <mat-icon class="material-icons-outlined">file_upload</mat-icon>Adjuntar Archivo
              </button><br/>
              <span>Archivos Excel o PDF </span>
            </div>
        </ng-container>
    </div>

    <div class="grid-attachment">
        <div class = "attachment" *ngFor="let f of executiveSummaryAttachment">
            <a
                class="attachment-link"
                href="{{dhoApiUrl}}/{{ f?.file_path }}"
                download="{{ f?.file_original_name }}"
                target="_blank"
            >
                {{ f?.file_original_name }}
            </a>
            <!-- Boton borrar-->
            <button
                *ngIf="!readOnlyContent"
                mat-button
                class="delete-button"
                (click)="deleteExecutiveSummaryAttachment(f.file_id)"
                [disabled]="readOnlyContent"
            >
                <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>
        </div>
    </div>

  </div>
  <div class="grid-container-ac">
    <div class="grid-item-ac">
      <mat-form-field>
        <mat-label>Resumen Ejecutivo</mat-label>
        <textarea matInput  maxlength="5000" [(ngModel)]="executiveSummary.executiveSummary" rows="5" [disabled]="readOnlyContent" (ngModelChange)="reportPendingChanges()"></textarea>
      </mat-form-field>
    </div>
    <div class="grid-item-ac edit-actions">
      <button mat-button class="ready" (click)="saveExecutiveSummary()" [disabled]="readOnlyContent">LISTO</button>
    </div>
  </div>
</div>
